import { Dispatch, SetStateAction } from 'react'
import { useGetMyCoursesQuery } from '@services/myCourses'
import { PER_PAGE } from '@const/pagination'
import { SortStates } from '@templates/ListPageLayout/Filters/Sorter'
import useItemsFilters, { FilterState } from './useItemsFilters'
import useMe from './useMe'

type Params = {
  initFilters?: FilterState
  pagination?: boolean
  limit?: number
  skip?: boolean
  initOrder?: { order: Record<string, SortStates> }
}

const useMyCourses = (params?: Params) => {
  const {
    initFilters = {},
    pagination = true,
    limit = PER_PAGE,
    skip,
    initOrder = { order: { createdAt: SortStates.DESC } },
  } = params || {}
  const { id } = useMe()

  const { filters, setFilters, setPage, setOrder, page } = useItemsFilters(
    initFilters,
    pagination,
    limit,
    initOrder,
    1
  )

  const handleSetPage: Dispatch<SetStateAction<number>> = (newPageAction) => {
    const newPage =
      newPageAction instanceof Function ? newPageAction(page) : newPageAction

    setPage(newPage)
  }

  const state = useGetMyCoursesQuery(filters, {
    skip: skip || !id,
    refetchOnMountOrArgChange: true,
    refetchOnFocus: false,
    refetchOnReconnect: false,
  })

  return {
    ...state,
    setPage: handleSetPage,
    setFilters,
    setOrder,
    page,
  }
}

export default useMyCourses
